// extracted by mini-css-extract-plugin
module.exports = {"ManageTemplateModule":"ManageTemplateTable_ManageTemplateModule__2595s","AssociatedCampaigns":"ManageTemplateTable_AssociatedCampaigns__3wONY"};